import Card from 'components/Card'
import DemandNativeAppAnalyticsMisc from 'components/misc/DemandNativeAppAnalyticsMisc'
import ExportDemandNativeAppStatsButton from 'components/misc/ExportDemandNativeAppStatsButton'
import Restricted from 'components/Restricted'
import Page from 'components/ui/Page'

const DemandAppAnalyticsPage = () => (
    <Page title="Demand App Analytics">
        <div className="m-auto max-w-screen-xl my-16 space-y-8">
            <h1>Demand App Analytics</h1>
            <Restricted location="admin" checkWrite={false} showMessage>
                <div className="space-y-8">
                    <Card header="Export Stats">
                        <ExportDemandNativeAppStatsButton />
                    </Card>
                    <DemandNativeAppAnalyticsMisc />
                </div>
            </Restricted>
        </div>
    </Page>
)

export default DemandAppAnalyticsPage
